<template>
    <div class="col-md-12">
        <div class="panel panel-visible" id="spy2">

            <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>

            <div class="panel-heading">
                <div class="panel-title hidden-xs">
                    <span class="glyphicon glyphicon-tasks"></span>Клиенты</div>
            </div>
            <div class="panel-body pn">
                <div class="dt-panelmenu clearfix">
                    <div class="dataTables_length">
                        <div class="filter-form">
                            <div class="row">
                                <div class="col-md-6">
                                Должность
                                    <vue-select
                                            placeholder="Все"
                                            :disabled="isLoading"
                                            :options="data.posts"
                                            v-model="filter.manager_id"
                                            :searchable="false"
                                            :reduce="post => post.id"
                                            label="name"
                                            class="filter-form-select-full-width"
                                    />
                                </div>
                                <div class="col-md-6">
                                Статус
                                    <vue-select
                                            placeholder="Все"
                                            :disabled="isLoading"
                                            :options="data.statuses"
                                            v-model="filter.status_id"
                                            :searchable="false"
                                            :reduce="status => status.id"
                                            label="name"
                                            class="filter-form-select-full-width"
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <per-pager v-bind:per-page="pagination.perPage"></per-pager>
                <table class="table table-striped table-hover datatables" id="clients_list" cellspacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>id</th>
                            <th>ФИО</th>
                            <th>Телефон</th>
                            <th>e-mail</th>
                            <th>Статус</th>
                            <th>Дата рождения</th>
                            <th>Дата регистрации</th>
                            <th>Ответственный</th>
                            <th>Менеджер</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(client, index) in clients" v-bind:key="index">
                            <td>{{client.id}}</td>
                            <td>
                                <router-link :to="{name: 'clients-edit', params: {id: client.id}}">
                                    {{client.fullName}}
                                </router-link>
                            </td>
                            <td>{{client.phone}}</td>
                            <td>{{client.email}}</td>
                            <td>{{(client.status && data.statuses.find(row => row.id === client.status)) ? data.statuses.find(row => row.id === client.status).name : 'Нет'}}</td>
                            <td>
                                <span v-if="client.birthday">{{client.birthday | moment('DD.MM.YYYY', 'YYYY-MM-DD')}}</span>
                            </td>
                            <td>{{client.createdAt | moment('DD.MM.YYYY')}}</td>
                            <td>
                                <select v-model="client.responsibleId" v-on:change="setResponsible(client)">
                                    <option value="0">Нет</option>
                                    <option v-for="user in data.users" v-bind:key="user.id" :value="user.id">
                                        {{user.fullName}}
                                    </option>
                                </select>
                            </td>
                          <td>
                            <select v-model="client.managerId" v-on:change="setManager(client)">
                              <option value="0">Нет</option>
                              <option v-for="onePost in data.posts" v-bind:key="onePost.id" :value="onePost.id">
                                {{onePost.name}}
                              </option>
                            </select>
                          </td>
                        </tr>
                    </tbody>
                </table>
                <paginator v-bind="pagination"></paginator>
            </div>
        </div>
    </div>
</template>

<script>
    import Client from "../../models/Client";
    import User from "../../models/User";
    import UserPost from "../../models/UserPost";
    import ClientStatus from "../../models/ClientStatus";

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
            Paginator: () => import('../data/Paginator'),
            PerPager: () => import('../data/PerPager'),
            VueSelect: () => import('vue-select'),
        },
        async beforeMount() {
            const me = await User.getMe();
            if (me.postId) {
                this.filter.manager_id = me.postId;
            }
            await this.loadData();
            await this.load();
        },
        async beforeRouteUpdate(to, from, next) {
            next();
            await this.loadData();
            await this.load();
        },
        data() {
            return {
                data: {
                    users: [],
                    posts: [],
                    statuses: ClientStatus.getStatuses(),
                },
                isLoading: false,
                pagination: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 0,
                    totalCount: 0,
                },
                clients: [],
                filter: {
                    manager_id: undefined,
                    status_id: undefined,
                },
            };
        },
        watch: {
            'pagination.perPage': function(value) {
                this.setDefaultPerPage(value);
            },
            'filter': {
                deep: true,
                handler: function() {
                    this.load();
                },
            },
        },
        methods: {
            async loadData() {
                let usersResponse, userPostsResponse;
                [usersResponse, userPostsResponse] = await Promise.all([
                    User.getList(1, 999),
                    UserPost.getList({}, 1, 'name', -1),
                ]);
                this.data.users = usersResponse.data;
                this.data.posts = [];
                for (let post of userPostsResponse.data) {
                    let user = this.data.users.find((user) => user.id === post.user_id);
                    if (user) {
                        post.name = `${user.fullName} - ${post.name}`;
                    }
                    this.data.posts.push(post);
                }
            },
            async load() {
                this.isLoading = true;

                const page = this.$route.query.page ? this.$route.query.page : 1;
                const perPage = this.$route.query['per-page'] ? this.$route.query['per-page'] : this.getDefaultPerPage();

                const clientResponse = await Client.getList(page, perPage, this.filter, '-created_at');
                this.setData(clientResponse.data, clientResponse.headers);

                this.isLoading = false;
            },
            async setResponsible(client) {
                this.isLoading = true;

                await client.setResponsible();

                this.isLoading = false;
            },
            async setManager(client) {
              this.isLoading = true;

              await client.setManager();

              this.isLoading = false;
            },
            getDefaultPerPage() {
                if (this.$store.state.template.perPages['clients-list']) {
                    return this.$store.state.template.perPages['clients-list'];
                }
                return 25;
            },
            setDefaultPerPage(value) {
                this.$store.commit('template/setPerPage', {name: 'clients-list', value: value})
            },
            setData(clients, headers) {
                this.clients = clients;
                this.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.pagination.totalCount = Number(headers['x-pagination-total-count']);
            }
        },
        metaInfo() {
            return {
                title: 'Клиенты - список',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>